import React from 'react';

import {
    Player,
    PlayerEmbed,
    PlayerPlaceholder,
    PlayerPlayButton
} from '$partials/base/player';
import { PlayIcon } from '$partials/icon';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').Video}
 */
const Video = ({
    video,
    posterImage,
    caption
}) => {
    // render
    return (
        <section className='col-12 relative'>
            <Player
                className='width-100'
                shouldPrerender={true}
                shouldToggleVisibility={posterImage ? true : false}>
                <PlayerEmbed>
                    <div
                        className='video-oembed'
                        dangerouslySetInnerHTML={{ __html: video?.html }} />
                </PlayerEmbed>

                <PlayerPlaceholder>
                    {posterImage && (
                        <div className='absolute height-100 width-100'>
                            <PlayerPlayButton className='form-field-reset button flex border-radius-100px video-player-button p5'>
                                <PlayIcon />
                            </PlayerPlayButton>
                        </div>
                    )}

                    {posterImage && (
                        <img
                            className='width-100'
                            height={video?.height}
                            loading='lazy'
                            src={posterImage?.src}
                            width={video?.width} />
                    )}
                </PlayerPlaceholder>
            </Player>
            {caption &&
                <figcaption>
                    <div
                        className='rich-text type-style-7 mt4'
                        dangerouslySetInnerHTML={{__html: caption}}/>
                </figcaption>
            }
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Video;
